export default function Footer() {
  return (
    <footer className="relative bg-[#0D0D0D] text-white overflow-hidden">
      <div className="h-1 w-full bg-gradient-to-r from-[#038C7F] via-[#F2780C] to-[#038C7F]"></div>

      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-16 right-16 w-48 sm:w-72 h-48 sm:h-72 bg-[#038C7F]/10 rounded-full blur-[100px] animate-pulse hidden sm:block"></div>
        <div
          className="absolute bottom-16 left-16 w-40 sm:w-60 h-40 sm:h-60 bg-[#F2780C]/10 rounded-full blur-[100px] animate-pulse hidden sm:block"
          style={{ animationDelay: '1s' }}
        ></div>
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        ></div>
      </div>

      <div className="pt-8 sm:pt-12 pb-4 sm:pb-6 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Newsletter Section */}
          <div className="relative mb-8 sm:mb-10 p-4 sm:p-6 lg:p-8 rounded-xl sm:rounded-2xl bg-gradient-to-br from-white/[0.03] to-white/[0.01] border border-white/10 backdrop-blur-sm overflow-hidden">
            <div className="absolute top-0 left-0 w-12 sm:w-16 h-12 sm:h-16 border-l-2 border-t-2 border-[#038C7F]/30 rounded-tl-xl sm:rounded-tl-2xl hidden sm:block"></div>
            <div className="absolute bottom-0 right-0 w-12 sm:w-16 h-12 sm:h-16 border-r-2 border-b-2 border-[#F2780C]/30 rounded-br-xl sm:rounded-br-2xl hidden sm:block"></div>

            <div className="flex flex-col lg:flex-row items-center justify-between gap-4 sm:gap-6">
              <div className="text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-2.5 sm:px-3 py-1 bg-[#038C7F]/20 rounded-full mb-2 sm:mb-3">
                  <i className="ri-mail-star-line text-[#038C7F] text-xs sm:text-sm"></i>
                  <span className="text-[9px] sm:text-[10px] font-bold text-[#038C7F] uppercase tracking-wider">Stay Updated</span>
                </div>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-1">Subscribe to Our Newsletter</h3>
                <p className="text-[10px] sm:text-xs text-gray-400">
                  Get the latest insights on branding, media, and creative trends in East Africa.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
                <div className="relative flex-1 lg:w-72">
                  <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm"></i>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full pl-9 sm:pl-10 pr-4 py-2.5 sm:py-3 bg-white/5 border border-white/10 rounded-lg text-white text-sm placeholder:text-gray-500 focus:outline-none focus:border-[#038C7F] transition-colors"
                  />
                </div>
                <button className="px-4 sm:px-5 py-2.5 sm:py-3 bg-gradient-to-r from-[#038C7F] to-[#026b61] text-white text-xs sm:text-sm font-bold rounded-lg hover:shadow-lg hover:shadow-[#038C7F]/25 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
                  <span>Subscribe</span>
                  <i className="ri-send-plane-2-line text-sm"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Main Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-6 mb-8 sm:mb-10">
            {/* Brand Column */}
            <div className="col-span-2 sm:col-span-3 lg:col-span-4">
              <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#038C7F] to-[#F2780C] rounded-lg sm:rounded-xl blur-lg opacity-50"></div>
                  <img
                    src="https://asili.co.ug/visuals/assets/img/logo-AsiliVisuals.png"
                    alt="Asili Visuals Logo"
                    className="relative h-10 sm:h-12 w-auto"
                  />
                </div>
              </div>
              <p className="text-[10px] sm:text-xs text-gray-400 leading-relaxed mb-4 sm:mb-6 max-w-sm">
                An integrated advertising and brand communication firm based in Kampala, delivering strategic communication systems that strengthen credibility, expand markets, and enhance brand equity across East Africa.
              </p>

              <div className="flex items-center gap-2">
                {[
                  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/company/asili-visuals', label: 'LinkedIn' },
                  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/asili_visuals', label: 'Instagram' },
                  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/asilivisuals', label: 'Facebook' },
                  { icon: 'ri-twitter-x-line', href: 'https://x.com/asili_visuals', label: 'X / Twitter' },
                  { icon: 'ri-tiktok-line', href: 'https://www.tiktok.com/@asili_visuals', label: 'TikTok' },
                  { icon: 'ri-youtube-line', href: 'https://www.youtube.com/@asilivisuals', label: 'YouTube' },
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    aria-label={social.label}
                    className="group w-8 h-8 sm:w-9 sm:h-9 bg-white/5 border border-white/10 rounded-lg flex items-center justify-center hover:bg-white/10 hover:border-white/20 hover:scale-110 transition-all duration-300 cursor-pointer"
                  >
                    <i
                      className={`${social.icon} text-sm sm:text-base text-gray-400 group-hover:text-white transition-colors`}
                    ></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Services Column */}
            <div className="col-span-1 lg:col-span-2">
              <h4 className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wider mb-3 sm:mb-4 flex items-center gap-2">
                <div className="w-6 h-6 sm:w-7 sm:h-7 bg-[#038C7F]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-service-line text-[#038C7F] text-xs sm:text-sm"></i>
                </div>
                <span className="hidden sm:inline">Services</span>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                {[
                  { name: 'Branding & Digital', icon: 'ri-palette-line', href: '#services' },
                  { name: 'Film & Media', icon: 'ri-film-line', href: '#services' },
                  { name: 'Outdoor Advertising', icon: 'ri-billboard-line', href: '#services' },
                  { name: 'Garment Manufacturing', icon: 'ri-t-shirt-line', href: '#services' },
                ].map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        const isHomePage = window.location.pathname === '/';
                        if (isHomePage) {
                          const element = document.querySelector(item.href);
                          if (element) {
                            element.scrollIntoView({ behavior: 'smooth' });
                          }
                        } else {
                          window.REACT_APP_NAVIGATE && window.REACT_APP_NAVIGATE('/');
                          setTimeout(() => {
                            const element = document.querySelector(item.href);
                            if (element) {
                              element.scrollIntoView({ behavior: 'smooth' });
                            }
                          }, 100);
                        }
                      }}
                      className="text-[10px] sm:text-xs text-gray-400 hover:text-[#038C7F] transition-colors cursor-pointer flex items-center gap-1.5 sm:gap-2 group"
                    >
                      <i
                        className={`${item.icon} text-[#038C7F]/50 group-hover:text-[#038C7F] transition-colors text-xs sm:text-sm`}
                      ></i>
                      <span className="hidden sm:inline">{item.name}</span>
                      <span className="sm:hidden">{item.name.split(' ')[0]}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Column */}
            <div className="col-span-1 lg:col-span-2">
              <h4 className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wider mb-3 sm:mb-4 flex items-center gap-2">
                <div className="w-6 h-6 sm:w-7 sm:h-7 bg-[#F2780C]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-building-2-line text-[#F2780C] text-xs sm:text-sm"></i>
                </div>
                <span className="hidden sm:inline">Company</span>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                {[
                  { name: 'About Us', href: '/about', icon: 'ri-information-line' },
                  { name: 'Our Process', href: '#process', icon: 'ri-flow-chart' },
                  { name: 'Portfolio', href: '/portfolio', icon: 'ri-gallery-line' },
                  { name: 'Contact', href: '/contact', icon: 'ri-mail-send-line' },
                ].map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.href.startsWith('/')) {
                          window.REACT_APP_NAVIGATE && window.REACT_APP_NAVIGATE(item.href);
                        } else {
                          const isHomePage = window.location.pathname === '/';
                          if (isHomePage) {
                            const element = document.querySelector(item.href);
                            if (element) {
                              element.scrollIntoView({ behavior: 'smooth' });
                            }
                          } else {
                            window.REACT_APP_NAVIGATE && window.REACT_APP_NAVIGATE('/');
                            setTimeout(() => {
                              const element = document.querySelector(item.href);
                              if (element) {
                                element.scrollIntoView({ behavior: 'smooth' });
                              }
                            }, 100);
                          }
                        }
                      }}
                      className="text-[10px] sm:text-xs text-gray-400 hover:text-[#F2780C] transition-colors cursor-pointer flex items-center gap-1.5 sm:gap-2 group"
                    >
                      <i
                        className={`${item.icon} text-[#F2780C]/50 group-hover:text-[#F2780C] transition-colors text-xs sm:text-sm`}
                      ></i>
                      <span>{item.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Regions Column */}
            <div className="col-span-1 lg:col-span-2 hidden sm:block">
              <h4 className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wider mb-3 sm:mb-4 flex items-center gap-2">
                <div className="w-6 h-6 sm:w-7 sm:h-7 bg-[#038C7F]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-earth-line text-[#038C7F] text-xs sm:text-sm"></i>
                </div>
                <span className="hidden sm:inline">We Serve</span>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                {[
                  { name: 'Uganda', flag: '🇺🇬' },
                  { name: 'Kenya', flag: '🇰🇪' },
                  { name: 'Tanzania', flag: '🇹🇿' },
                  { name: 'Rwanda', flag: '🇷🇼' },
                  { name: 'South Sudan', flag: '🇸🇸' },
                ].map((item) => (
                  <li
                    key={item.name}
                    className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400 group cursor-default"
                  >
                    <span className="text-sm sm:text-base group-hover:scale-125 transition-transform">{item.flag}</span>
                    <span className="group-hover:text-white transition-colors">{item.name}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div className="col-span-2 sm:col-span-1 lg:col-span-2">
              <h4 className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wider mb-3 sm:mb-4 flex items-center gap-2">
                <div className="w-6 h-6 sm:w-7 sm:h-7 bg-[#F2780C]/20 rounded-lg flex items-center justify-center">
                  <i className="ri-phone-line text-[#F2780C] text-xs sm:text-sm"></i>
                </div>
                <span className="hidden sm:inline">Contact</span>
              </h4>
              <ul className="space-y-2 sm:space-y-3">
                <li>
                  <a
                    href="mailto:info@asili.co.ug"
                    className="flex items-start gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400 hover:text-white transition-colors cursor-pointer group"
                  >
                    <i className="ri-mail-line text-[#038C7F] mt-0.5 text-xs sm:text-sm"></i>
                    <span className="break-all sm:break-normal">info@asili.co.ug</span>
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+256761375736"
                    className="flex items-start gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400 hover:text-white transition-colors cursor-pointer group"
                  >
                    <i className="ri-phone-line text-[#038C7F] mt-0.5 text-xs sm:text-sm"></i>
                    <span>0761 375736</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/256761375736"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-start gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400 hover:text-white transition-colors cursor-pointer group"
                  >
                    <i className="ri-whatsapp-line text-[#25D366] mt-0.5 text-xs sm:text-sm"></i>
                    <span>WhatsApp Us</span>
                  </a>
                </li>
                <li className="flex items-start gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400">
                  <i className="ri-map-pin-2-line text-[#F2780C] mt-0.5 text-xs sm:text-sm"></i>
                  <span>Block B&C 3rd Floor, Ntinda Shopping Complex, Kampala, Uganda</span>
                </li>
                <li className="flex items-start gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-gray-400">
                  <i className="ri-time-line text-[#038C7F] mt-0.5 text-xs sm:text-sm"></i>
                  <span>Mon – Fri: 9AM – 6PM EAT</span>
                </li>
              </ul>

              <a
                href="/contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE && window.REACT_APP_NAVIGATE('/contact');
                }}
                className="mt-3 sm:mt-4 inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-[#F2780C] to-[#d96a0a] text-white text-[10px] sm:text-xs font-bold rounded-lg hover:shadow-lg hover:shadow-[#F2780C]/25 transition-all cursor-pointer whitespace-nowrap"
              >
                <span>Get a Quote</span>
                <i className="ri-arrow-right-line text-xs sm:text-sm"></i>
              </a>
            </div>
          </div>

          {/* Awards Bar */}
          <div className="mb-6 sm:mb-8 py-4 sm:py-6 border-y border-white/10">
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 lg:gap-12">
              {[
                { icon: 'ri-award-line', label: 'Award Winning', color: '#038C7F' },
                { icon: 'ri-verified-badge-line', label: 'Certified Agency', color: '#F2780C' },
                { icon: 'ri-shield-check-line', label: 'Trusted Partner', color: '#038C7F' },
                { icon: 'ri-global-line', label: 'East Africa Wide', color: '#F2780C' },
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-1.5 sm:gap-2 text-gray-500">
                  <div className="w-6 h-6 sm:w-8 sm:h-8 bg-white/5 rounded-full flex items-center justify-center">
                    <i className={`${item.icon} text-xs sm:text-sm`} style={{ color: item.color }}></i>
                  </div>
                  <span className="text-[9px] sm:text-[10px] font-medium uppercase tracking-wider hidden sm:inline">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
            <div className="flex items-center gap-2 text-[10px] sm:text-xs text-gray-500">
              <div className="w-5 h-5 sm:w-6 sm:h-6 bg-white/5 rounded-lg flex items-center justify-center">
                <i className="ri-copyright-line text-[#038C7F] text-[10px] sm:text-xs"></i>
              </div>
              <span>© 2026 Äsili Visuals. All rights reserved.</span>
            </div>

            <div className="flex items-center gap-3 sm:gap-4">
              <a
                href="#"
                className="text-[9px] sm:text-[10px] text-gray-500 hover:text-white transition-colors cursor-pointer flex items-center gap-1"
              >
                <i className="ri-shield-keyhole-line text-[#038C7F] text-[10px] sm:text-xs"></i>
                <span className="hidden sm:inline">Privacy Policy</span>
                <span className="sm:hidden">Privacy</span>
              </a>
              <a
                href="#"
                className="text-[9px] sm:text-[10px] text-gray-500 hover:text-white transition-colors cursor-pointer flex items-center gap-1"
              >
                <i className="ri-file-list-3-line text-[#F2780C] text-[10px] sm:text-xs"></i>
                <span className="hidden sm:inline">Terms of Service</span>
                <span className="sm:hidden">Terms</span>
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[9px] sm:text-[10px] text-gray-500 hover:text-white transition-colors cursor-pointer"
              >
                Web Design
              </a>
            </div>

            <a
              href="https://ekamu.tech"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-1 sm:py-1.5 bg-white/5 border border-white/10 rounded-lg hover:bg-white/10 hover:border-[#038C7F]/50 transition-all cursor-pointer group"
            >
              <i className="ri-flashlight-line text-[#038C7F] text-xs sm:text-sm group-hover:animate-pulse"></i>
              <span className="text-[9px] sm:text-[10px] text-gray-400 group-hover:text-white transition-colors">
                Powered by <span className="font-bold text-[#038C7F]">Ekamutech</span>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="h-1 w-full bg-gradient-to-r from-[#F2780C] via-[#038C7F] to-[#F2780C]"></div>
    </footer>
  );
}
